import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {iResponseSendCodeRegisterExpress} from 'src/app/data/networking/models/customer/responses/customer-res';
import {CustomerManager} from '../../data/manager/customer/customer/customer.manager';

@Injectable({
  providedIn: 'root',
})
export class SelectValidationVm {
  constructor(private customerManager: CustomerManager) { }

  sendMessage(dataSendCode): Observable<iResponseSendCodeRegisterExpress> {
    return this.customerManager.sendMessage(dataSendCode);
  }
}
